/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Outlook_Read_ErrorInputs */

const es_tools_outlook_read_error = /** @type {(inputs: Tools_Outlook_Read_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al leer correo de Outlook`)
};

const en_tools_outlook_read_error = /** @type {(inputs: Tools_Outlook_Read_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error reading Outlook message`)
};

/**
* | output |
* | --- |
* | "Error reading Outlook message" |
*
* @param {Tools_Outlook_Read_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_outlook_read_error = /** @type {((inputs?: Tools_Outlook_Read_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Outlook_Read_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_outlook_read_error(inputs)
	return en_tools_outlook_read_error(inputs)
});
export { tools_outlook_read_error as "tools.outlook.read_error" }